import { StyleProp, ViewStyle, TextStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';

export const CheckmarkIcon = nativewindWrapSvg(
  ({ style, stroke = "#fff" }: { style: StyleProp<ViewStyle>, stroke: string }) => {
    return (
      <Svg
        width={16}
        height={12}
        viewBox="0 0 16 12"
        style={style}
        fillOpacity={0}
      >
        <Path
          d="M14.234 2l-8.937 8.938-4.063-4.063"
          stroke={stroke}
          strokeWidth={1.5}
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }
);
